import {
  TYPE_GUEST,
  TYPE_MEMBER,
} from '@/constants/userPermissions';
export const getDefaultState = () => ({
  activeWorkspaceId: null,
  activeWorkspaceLogoUrl: null,
  activeWorkspacePrefix: 'active_workspace_',
  guestUsers: [],
  isFetching: {
    workspacePages: false,
  },
  invitedUsersForShareWorkspace: [],
  memberUsers: [],
  needRedirect: false,
  userPremium: false,
  workspacePagePublished: false,
  workspacePagesForSpecifiedWs: [],
  workspacesList: [],
  workspacesListForFollowing: [],
  workspaceUserTypes: [TYPE_MEMBER, TYPE_GUEST],
});
export const state = getDefaultState();
